import React, { memo } from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import HomeGreeting from '../greeting';
import SpaceCardSkeleton from './SpaceCardSkeleton';
import {
  GREETING_CARD_HEIGHT_PX,
  GREETING_CARD_WIDTH_PX,
  SPACE_CARD_GAP_PX,
  SPACE_CARD_HEIGHT_PX,
  SPACE_CARD_SKELETON_SURFACE,
} from './spaceWidgetConstants';

export type SpaceWidgetSkeletonProps = {
  cardCount?: number;
  showGreeting?: boolean;
};

const greetingItemSx = {
  width: `${GREETING_CARD_WIDTH_PX}px`,
  maxWidth: `${GREETING_CARD_WIDTH_PX}px`,
  height: `${GREETING_CARD_HEIGHT_PX}px`,
  minHeight: `${GREETING_CARD_HEIGHT_PX}px`,
  flexShrink: 0,
  '& > section': {
    width: '100%',
    height: '100%',
    minHeight: `${GREETING_CARD_HEIGHT_PX}px`,
  },
};

const SpaceWidgetSkeleton = ({
  cardCount = 4,
  showGreeting = false,
}: SpaceWidgetSkeletonProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: `${SPACE_CARD_GAP_PX}px`,
      overflow: 'hidden',
      minWidth: 0,
      width: '100%',
      minHeight: { lg: `${SPACE_CARD_HEIGHT_PX}px` },
    }}
  >
    {showGreeting ? (
      <Box
        id="home-greeting-widget"
        aria-label="Greeting Widgets"
        sx={greetingItemSx}
      >
        <HomeGreeting />
      </Box>
    ) : null}

    <Box
      component="section"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading your spaces"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        gap: `${SPACE_CARD_GAP_PX}px`,
        overflow: 'hidden',
        minWidth: 0,
        minHeight: `${SPACE_CARD_HEIGHT_PX}px`,
      }}
    >
      {Array.from({ length: cardCount }, (_, index) => (
        <SpaceCardSkeleton
          key={`space-card-skeleton-${index}`}
          skeletonSurface={SPACE_CARD_SKELETON_SURFACE}
        />
      ))}
    </Box>
  </Box>
);

export default memo(SpaceWidgetSkeleton);
